import React, { useEffect, useState } from "react";
import personalBg from "../../assets/images/personal-bg.svg";
import ConfirmationCard from "../../components/ConfirmationCard";
import PersonalTourCards from "./sections/PersonalTourCards";
import Modal from "../../components/Modal";
import EditBooking from "./sections/EditBooking";
import CancelBooking from "./sections/CancelBooking";
import Tours from "../verification/sections/Tours";
import { useModal } from "../../contexts/ModalContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchToursThunk } from "../../lib/service/tours/toursSlice";
import { fetchCategoriesThunk } from "../../lib/service/categories/categoriesSlice";
import { fetchToursDetailsThunk } from "../../lib/service/tours/toursDetailsSlice";
import { fetchBookingsAsync } from "../../lib/service/bookings/bookingsSlice";
import Cookies from "js-cookie";
import { fetchCategoriesAfterBookingThunk } from "../../lib/service/categories/categoriesAfterBookingSlice";
import { fetchToursDetailsAfterBookingThunk } from "../../lib/service/tours/toursDetailsAfterBookingSlice";
import { useTransformedData } from "../../contexts/TransformedDataContext";
import Spinner from "../../components/Spinner";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useSelectedTours } from "../../contexts/SelectedToursContext";
import ConfirmationBooking from "../../components/ConfirmationBooking";
import { fetchVenuesThunk } from "../../lib/service/venues/venuesSlice";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../../contexts/AuthContext";
const toursDummy = [
  { title: "GOVERNMENTS", name: "tour 1", time: "01.00 TO 01.45" },
  { title: "TECH 2", name: "tour 2", time: "02.00 TO 02.45" },
];
const divStyle = {
  backgroundImage: `url(${personalBg})`,
  backgroundSize: "cover", // Or "contain" depending on your preference
  backgroundPosition: "center", // Center the background image
  backgroundAttachment: "fixed", // Makes the background fixed
  width: "100%",
  // Use 100vh for full viewport height
};

function PersonalPage() {
  const [namesArray, setNamesArray] = useState([]);
  const { transformedData, setTransformedData } = useTransformedData();
  const [categoryIdsArray, setCategoryIdsArray] = useState([]);
  const [tourIdsArray, setTourIdsArray] = useState([]);
  const [venuesIdsArray, setVenuesIdsArray] = useState([]);
  const { selectedTours, setSelectedTours } = useSelectedTours();
  const { logout } = useAuth();

  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // Smooth scrolling
      });
    }, 200); // 200ms delay to ensure rendering is complete
  }, []);
  const [isConfirmationCardVisible, setIsConfirmationCardVisible] =
    useState(false);
  const {
    isChangeModalOpen,
    setIsChangeModalOpen,
    isCancelModalOpen,
    setIsCancelModalOpen,
  } = useModal();

  const {
    venues,
    status: venuesStatus,
    error: venuesError,
  } = useSelector((state) => state.venues);

  const {
    data: UpdateAttendanceData,
    loading: UpdateAttendanceLoading,
    error: UpdateAttendanceError,
  } = useSelector((state) => state.updateAttendance);
  const { tours, loading, error } = useSelector((state) => state.tours);

  const {
    details,
    loading: detailsLoading,
    error: detailsError,
  } = useSelector((state) => state.toursDetails);
  const {
    bookings,
    loading: bookingsLoading,
    error: bookingsError,
  } = useSelector((state) => state.bookings);

  const {
    categories,
    loading: categoriesLoading,
    error: categoriesError,
  } = useSelector((state) => state.categories);

  const dispatch = useDispatch();
  const bookingsByDate = bookings?.data?.bookings_by_date || {};

  const processVenues = (venues) => {
    return venues?.map((venue) => {
      let startGate = null;
      let endGate = null;

      venue.attributes.forEach((attribute) => {
        attribute.gates.forEach((gate) => {
          if (gate.type === 1 && gate.catalogs.length > 0 && !startGate) {
            startGate = {
              gate: gate.name,
              catalog: gate.catalogs,
              attributeId: attribute.id,
              venueId: venue.id,
            };
          }

          if (gate.type === 2 && gate.catalogs.length > 0 && !endGate) {
            endGate = {
              gate: gate.name,
              catalog: gate.catalogs,
              attributeId: attribute.id,
              venueId: venue.id,
            };
          }
        });
      });

      return {
        venueId: venue.id,
        name: venue.name,
        startGate,
        endGate,
      };
    });
  };
  const processedVenues = processVenues(venues?.data?.data);

  useEffect(() => {
    // Extract data only if bookingsByDate has data
    if (!bookingsByDate || Object.keys(bookingsByDate).length === 0) {
      return;
    }

    const extractedTourIds = [];
    const extractedCategoryIds = [];
    const extractedVenuesIds = [];

    Object.values(bookingsByDate).forEach((dateBookings) => {
      dateBookings.forEach((booking) => {
        booking.items.forEach((item) => {
          // Add unique tour_id
          if (!extractedTourIds.includes(item.tour_id)) {
            extractedTourIds.push(item.tour_id);
          }

          // Add unique category_ids
          if (!extractedCategoryIds.includes(item.category_ids)) {
            extractedCategoryIds.push(item.category_ids);
          }
          // Add unique venue_id
          if (!extractedVenuesIds.includes(item.venue_id)) {
            extractedVenuesIds.push(item.venue_id);
          }
        });
      });
    });

    if (
      JSON.stringify(categoryIdsArray) !== JSON.stringify(extractedCategoryIds)
    ) {
      setCategoryIdsArray(extractedCategoryIds);
    }

    if (JSON.stringify(tourIdsArray) !== JSON.stringify(extractedTourIds)) {
      setTourIdsArray(extractedTourIds);
    }

    if (JSON.stringify(venuesIdsArray) !== JSON.stringify(extractedVenuesIds)) {
      setVenuesIdsArray(extractedVenuesIds);
    }
  }, [bookingsByDate]); // Only re-run when bookingsByDate changes

  const {
    loading: loadingStatus,
    success,
    error: errorStatus,
  } = useSelector((state) => state.toursStatus);
  useEffect(() => {
    // Dispatch the fetchBookingsAsync action
    dispatch(fetchBookingsAsync()).unwrap();
  }, [dispatch, loadingStatus, success, errorStatus, UpdateAttendanceData]);

  useEffect(() => {
    // Check if all arrays have data before proceeding
    if (
      categoryIdsArray?.length === 0 ||
      tourIdsArray?.length === 0 ||
      venuesIdsArray?.length === 0
    ) {
      return; // Wait until all arrays are populated
    }

    const fetchData = async () => {
      try {
        // Fetch categories, tours details, and venues simultaneously
        const [categoriesResponse, toursDetailsResponse, venuesResponse] =
          await Promise.all([
            dispatch(
              fetchCategoriesAfterBookingThunk({
                category_ids: categoryIdsArray,
              })
            ).unwrap(),
            dispatch(
              fetchToursDetailsAfterBookingThunk({
                products_id: tourIdsArray,
              })
            ).unwrap(),
            dispatch(
              fetchVenuesThunk({
                venues_ids: venuesIdsArray,
              })
            ).unwrap(),
          ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [categoryIdsArray, tourIdsArray, venuesIdsArray, dispatch]);

  useEffect(() => {
    if (isCancelModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isCancelModalOpen]);

  const toggleConfirmationCard = () => {
    setIsConfirmationCardVisible((prevState) => !prevState);
  };
  const closeModal = () => {
    setIsChangeModalOpen(false);
    setIsCancelModalOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Booked Tours - Leap</title>
        <meta
          name="description"
          content="Manage your personal information and bookings on Leap."
        />
      </Helmet>
      <div
        style={divStyle}
        className={`leap-flex leap-justify-between   ${isChangeModalOpen ? "leap-overflow-auto" : "leap-overflow-auto"} `}
      >
        {bookingsLoading ? (
          <div className="leap-h-screen leap-w-full leap-flex leap-items-center leap-justify-center leap-relative">
            <Spinner />
          </div>
        ) : (
          <>
            {Object.values(bookingsByDate).every((item) =>
              item.every((i) => i.items.length == 0)
            ) || Object.keys(bookingsByDate).length === 0 ? (
              // Show message when there are no tours reserved
              <div className="lg:leap-h-[73.25dvh] leap-h-[62.8dvh] leap-px-2 leap-text-base leap-w-full leap-flex leap-uppercase  leap-items-center leap-justify-center leap-text-[#73FAFD] md:leap-text-2xl leap-font-bold">
                You have no booked tours
              </div>
            ) : (
              <>
                <div className="leap-mx-auto leap-px-2">
                  <PersonalTourCards
                    bookingsByDate={bookingsByDate} // Pass transformedObject here
                    onToggleConfirmationCard={toggleConfirmationCard}
                    isConfirmationCardVisible={isConfirmationCardVisible}
                    setIsChangeModalOpen={setIsChangeModalOpen}
                    setIsCancelModalOpen={setIsCancelModalOpen}
                    processedVenues={processedVenues}
                  />
                </div>

                <div className="">
                  {isChangeModalOpen.open && (
                    <EditBooking
                      itemId={isChangeModalOpen.itemId}
                      title={isChangeModalOpen.title}
                      date={isChangeModalOpen.date}
                      tourType={isChangeModalOpen.tourType}
                      attendanceId={isChangeModalOpen.attendanceId}
                      closeModal={closeModal}
                      bookingsByDate={bookingsByDate || {}}
                      onClick={closeModal}
                      categoryIdsArray={categoryIdsArray}
                      tourIdsArray={tourIdsArray}
                    />
                  )}

                  {isCancelModalOpen.open && (
                    <Modal isOpen={isCancelModalOpen}>
                      <CancelBooking
                        itemId={isCancelModalOpen.itemId}
                        title={isCancelModalOpen.title}
                        tourType={isCancelModalOpen.tourType}
                        date={isCancelModalOpen.date}
                        attendanceId={isCancelModalOpen.attendanceId}
                        onClick={closeModal}
                      />
                    </Modal>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default PersonalPage;
